var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClicked = function SvgClicked(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    fill: "none",
    viewBox: "0 0 25 25"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.4414,
    cy: 12.832,
    r: 11,
    fill: "#BC1BC6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M11.6497 9.33203V10.4987H8.73307V16.9154H15.1497V13.9987H16.3164V17.4987C16.3164 17.6534 16.2549 17.8018 16.1456 17.9112C16.0362 18.0206 15.8878 18.082 15.7331 18.082H8.14974C7.99503 18.082 7.84666 18.0206 7.73726 17.9112C7.62786 17.8018 7.56641 17.6534 7.56641 17.4987V9.91536C7.56641 9.76065 7.62786 9.61228 7.73726 9.50289C7.84666 9.39349 7.99503 9.33203 8.14974 9.33203H11.6497ZM18.0664 7.58203V12.2487H16.8997V9.57295L12.3538 14.1194L11.529 13.2946L16.0743 8.7487H13.3997V7.58203H18.0664Z"
  })));
};
export default SvgClicked;